import { render, staticRenderFns } from "./JobberCoverage.vue?vue&type=template&id=a584d0c4"
import script from "./JobberCoverage.vue?vue&type=script&lang=js"
export * from "./JobberCoverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports